import { useAuth } from "../../auth/context";

const useIsInstitutionalUser = () => {
  const { user } = useAuth();
  const healthCenterId = user.profile?.healthCenter;
  const myHealthCenterId = user.myHealthCenter?.id;

  return !!healthCenterId || !!myHealthCenterId;
};

export default useIsInstitutionalUser;
